module.exports = __webpack_public_path__ + "img/empty_heart.db242034.svg";